import create from "zustand";

export const useStore = create((set) => ({
  page: 0,
  setPage: (value) => set((state) => ({ page: value })),

  objectSelected: [],
  setObjectSelected: (value) => set((state) => ({ objectSelected: value })),
  isDragging: false,
  setIsDragging: (value) => set((state) => ({ isDragging: value })),
  project: null,
  setProject: (value) => set((state) => ({ project: value })),

  experienceContent: null,
  setExperienceContent: (value) =>
    set((state) => ({ experienceContent: value })),
}));
